import fadeinSliderObserver from "./fadeInHorizontalSlider";

(function () {

  window.addEventListener('DOMContentLoaded', (event) => {
    const reviewsToFadeIn = document.querySelectorAll(".google-reviews .review");
    const postsToFadeIn = document.querySelectorAll(".post-slider .post");

    reviewsToFadeIn.forEach(el => {
      el.classList.add("crafted-anim-slider-element");
      fadeinSliderObserver.observe(el);
    })

    postsToFadeIn.forEach(el => {
      el.classList.add("crafted-anim-slider-element");
      fadeinSliderObserver.observe(el);
    })

  });

})();
